(function () {
  if (window.__customCartDrawerInit) return;
  window.__customCartDrawerInit = true;

  var drawer = null;
  var sectionId = null;
  var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var lastFocused = null;
  var cartLoading = false;

  function getDrawer() {
    if (!drawer || !document.contains(drawer)) {
      drawer = document.querySelector('[data-custom-cart-drawer]');
      sectionId = drawer && drawer.getAttribute('data-section-id');
    }
    return drawer;
  }

  function sectionsUrl() {
    return window.location.pathname + window.location.search;
  }

  function sectionPayload(extra) {
    return Object.assign({}, extra, {
      sections: sectionId,
      sections_url: sectionsUrl(),
    });
  }

  function setCartLoading(busy) {
    cartLoading = busy;
    var el = getDrawer();
    if (!el) return;
    var panel = el.querySelector('[data-custom-cart-panel]');
    var loader = panel && panel.querySelector('[data-custom-cart-loader]');
    el.setAttribute('aria-busy', busy ? 'true' : 'false');
    if (panel) panel.classList.toggle('is-api-loading', busy);
    if (loader) loader.setAttribute('aria-hidden', busy ? 'false' : 'true');
  }
  function updateHeaderCartCount(count) {
    document
      .querySelectorAll(".cart-link__bubble-num, .trackbar-cart__bubble")
      .forEach(function (el) {
        el.textContent = count;
      });
    document.querySelectorAll(".cart-link__bubble").forEach(function (el) {
      if (count > 0) el.classList.add("cart-link__bubble--visible");
      else el.classList.remove("cart-link__bubble--visible");
    });
    document.querySelectorAll(".trackbar-cart__bubble").forEach(function (el) {
      if (count > 0) el.classList.remove("trackbar-cart__bubble--hidden");
      else el.classList.add("trackbar-cart__bubble--hidden");
    });
  }

  document.addEventListener("ajaxProduct:added", function () {
    postCart("cart/update.js", { updates: {} }).then(function () {
      if (window.openCustomCartDrawer) window.openCustomCartDrawer();
    });
  });

  function postCart(endpoint, payload) {
    if (!sectionId) return Promise.reject();
    setCartLoading(true);
    return fetch(cartRoot + endpoint, {
      method: "POST",
      headers: jsonHeaders,
      body: JSON.stringify(sectionPayload(payload)),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        if (typeof data.item_count !== "undefined") {
          updateHeaderCartCount(data.item_count);
        } else {
          fetch(cartRoot + "cart.js")
            .then(function (res) {
              return res.json();
            })
            .then(function (cart) {
              updateHeaderCartCount(cart.item_count);
            });
        }
        applySectionFromResponse(data);
        document.dispatchEvent(
          new CustomEvent("cart:updated", { detail: data }),
        );
        return data;
      })
      .finally(function () {
        setCartLoading(false);
      });
  }

  function applySectionFromResponse(data) {
    var html = data && data.sections && sectionId && data.sections[sectionId];
    if (html) refreshCartDrawer(html);
  }

  function refreshCartDrawer(html) {
    var el = getDrawer();
    if (!el) return;
    var source = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-custom-cart-drawer]');
    if (!source) return;

    var count = source.querySelector('.custom-cart-drawer__item-count');
    var countEl = el.querySelector('.custom-cart-drawer__item-count');
    if (count && countEl) countEl.textContent = count.textContent;

    var target = el.querySelector('[data-custom-cart-refresh]');
    var next = source.querySelector('[data-custom-cart-refresh]');
    if (!target || !next) return;

    teardownCartRecSwiper(el.querySelector('[data-cart-rec-root]'));
    target.innerHTML = next.innerHTML;
    requestAnimationFrame(mountCartRecSwiper);
  }

  function openCustomCartDrawer() {
    var el = getDrawer();
    if (!el) return;
    lastFocused = document.activeElement;
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('custom-cart-drawer-open');
    var closeBtn = el.querySelector('[data-custom-cart-close]');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
    setTimeout(function () {
      var root = el.querySelector('[data-cart-rec-root]');
      if (root && root._cartRecSwiper) root._cartRecSwiper.update();
    }, 200);
  }

  function closeCustomCartDrawer() {
    var el = getDrawer();
    if (!el) return;
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('custom-cart-drawer-open');
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  window.openCustomCartDrawer = openCustomCartDrawer;
  window.closeCustomCartDrawer = closeCustomCartDrawer;

  function updateCartLineQuantity(selector, quantity) {
    if (selector.dataset.loading === 'true' || cartLoading) return;
    var line = parseInt(selector.getAttribute('data-line'), 10);
    if (isNaN(line) || line < 1) return;

    selector.dataset.loading = 'true';
    postCart('cart/change.js', { line: line, quantity: quantity })
      .catch(function () {})
      .finally(function () {
        selector.dataset.loading = 'false';
      });
  }

  function handleCartRecAdd(button) {
    if (button.disabled || button.dataset.loading === 'true' || cartLoading) return;
    var variantId = parseInt(button.getAttribute('data-variant-id'), 10);
    if (!variantId) return;
    var label = button.getAttribute('data-add-label') || 'Add';

    button.dataset.loading = 'true';
    button.textContent = 'Adding…';

    postCart('cart/add.js', { items: [{ id: variantId, quantity: 1 }] })
      .catch(function () {
        button.textContent = 'Error';
        setTimeout(function () {
          if (button.isConnected) button.textContent = label;
        }, 1500);
      })
      .finally(function () {
        button.dataset.loading = 'false';
        if (button.isConnected) button.textContent = label;
      });
  }

  function teardownCartRecSwiper(root) {
    if (root && root._cartRecSwiper) {
      root._cartRecSwiper.destroy(true, true);
      root._cartRecSwiper = null;
    }
  }

  function mountCartRecSwiper() {
    if (typeof Swiper === 'undefined') return;
    var el = getDrawer();
    var root = el && el.querySelector('[data-cart-rec-root]');
    var swiperEl = el && el.querySelector('[data-cart-rec-swiper]');
    if (!root || !swiperEl) return;

    teardownCartRecSwiper(root);
    var prev = root.querySelector('.custom-cart-rec__nav--prev');
    var next = root.querySelector('.custom-cart-rec__nav--next');
    var opts = {
      slidesPerView: 1.2,
      spaceBetween: 36,
      watchOverflow: true,
      breakpoints: {
        750: { slidesPerView: 1.25, spaceBetween: 36 },
        990: { slidesPerView: 1.4, spaceBetween: 64 },
      },
    };
    if (prev && next) opts.navigation = { prevEl: prev, nextEl: next };
    root._cartRecSwiper = new Swiper(swiperEl, opts);
  }

  function bindDrawerEvents() {
    var el = getDrawer();
    if (!el || el.dataset.customCartBound === 'true') return;
    el.dataset.customCartBound = 'true';

    var overlay = el.querySelector('[data-custom-cart-overlay]');
    var panel = el.querySelector('[data-custom-cart-panel]');
    var closeBtn = el.querySelector('[data-custom-cart-close]');

    if (overlay) overlay.addEventListener('click', closeCustomCartDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeCustomCartDrawer);

    if (!panel) return;

    panel.addEventListener('click', function (event) {
      var addBtn = event.target.closest('[data-cart-rec-add]');
      if (addBtn) {
        event.preventDefault();
        handleCartRecAdd(addBtn);
        return;
      }

      var removeBtn = event.target.closest('[data-cart-remove]');
      if (removeBtn) {
        event.preventDefault();
        var row = removeBtn.closest('[data-cart-item]');
        var selector = row && row.querySelector('[data-quantity-selector]');
        if (selector) updateCartLineQuantity(selector, 0);
        return;
      }

      var qtyBtn = event.target.closest('[data-quantity-action]');
      if (!qtyBtn) return;
      var selector = qtyBtn.closest('[data-quantity-selector]');
      var input = selector && selector.querySelector('[data-quantity-input]');
      if (!input) return;
      var current = parseInt(input.value, 10) || 0;
      var next = qtyBtn.getAttribute('data-quantity-action') === 'increase' ? current + 1 : current - 1;
      updateCartLineQuantity(selector, Math.max(0, next));
    });

    panel.addEventListener('change', function (event) {
      var input = event.target.closest('[data-quantity-input]');
      if (!input) return;
      var selector = input.closest('[data-quantity-selector]');
      if (!selector) return;
      var next = parseInt(input.value, 10);
      updateCartLineQuantity(selector, isNaN(next) || next < 0 ? 0 : next);
    });
  }

  function closeSubscriptionSelects() {
    var el = getDrawer();
    if (!el) return;
    el.querySelectorAll('.subscription-select-container').forEach(function (node) {
      node.style.display = 'none';
    });
  }

  window.upgradeToSubscription = function (button) {
    button.style.display = 'none';
    var regularButton = button.nextElementSibling;
    if (regularButton) regularButton.style.display = 'flex';
    closeSubscriptionSelects();
  };

  window.toggleSubscriptionSelect = function (button) {
    var container = button.nextElementSibling;
    if (!container) return;
    var isVisible = container.style.display !== 'none';
    closeSubscriptionSelects();
    container.style.display = isVisible ? 'none' : 'block';
  };

  window.selectSubscriptionPlan = function (optionElement) {
    var container = optionElement.closest('.subscription-select-container');
    if (!container) return;
    container.querySelectorAll('.subscription-option').forEach(function (option) {
      option.classList.remove('active');
    });
    optionElement.classList.add('active');
    var subscriptionBtn = container.parentElement.querySelector('.subscription-btn-text');
    var selectedTitle = optionElement.querySelector('.subscription-option-title');
    if (subscriptionBtn && selectedTitle) subscriptionBtn.textContent = selectedTitle.textContent;
    container.style.display = 'none';
  };

  function init() {
    getDrawer();
    bindDrawerEvents();
    mountCartRecSwiper();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[data-custom-cart-drawer]')) {
      drawer = null;
      getDrawer();
      mountCartRecSwiper();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var el = getDrawer();
    if (el && el.getAttribute('aria-hidden') === 'false') closeCustomCartDrawer();
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-open-custom-cart], .js-drawer-open-cart');
    if (!trigger) return;
    event.preventDefault();
    openCustomCartDrawer();
  }, true);
})();
